import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

export const supplierOrdersUrl = '/supplier-orders'
export const supplierOrderDetailUrl = `/supplier-orders/:orderNumber`
export const supplierOrderPrintUrl = `/supplier-orders/:orderUUID(${UUIDPathRegex})/print`
export const supplierOrderWholesalersUrl = `/supplier-orders/:orderUUID(${UUIDPathRegex})/wholesalers`
export const supplierOrderChecklistPrintUrl =
  `/supplier-orders/:orderUUID(${UUIDPathRegex})/checklist/` + `:checklistUUID(${UUIDPathRegex})/print`
